import { DataGlueGraph, FunctionDefinition, NodeInstance } from '@glueapp/graph-types';
import { getDefaultValueForDataType, matchesDataType } from '@glueapp/graph-types';
import { dictionaryFromStringTuple } from '@glueapp/graph-types';

// TODO there is probably a long existing opportunity here to only create new node instance objects if there is actually a change.
export const updateNodePortValues = (nodeInstance: NodeInstance): NodeInstance => {
    const preExistingPortValues = nodeInstance.portValues;

    return {
        ...nodeInstance,
        portValues: dictionaryFromStringTuple(nodeInstance.inPorts, port => {
            const correspondingPortValue = preExistingPortValues[port.name];
            const correspondingUserDefinedType = nodeInstance.portUserDefinedTypes[port.name];
            const portType = port.type;

            if (portType) {
                if (correspondingPortValue !== null && matchesDataType(correspondingPortValue, portType, correspondingUserDefinedType)) {
                    return [port.name, correspondingPortValue];
                } else {
                    const isPortOptional = port.optional || portType.kind === 'optional';
                    if (isPortOptional) {
                        return null;
                    }
                    return [port.name, getDefaultValueForDataType(portType)];
                }
            } else {
                return [port.name, null];
            }
        }),
    };
};

export const updateFunctionPortValues = (functionDef: FunctionDefinition): FunctionDefinition => {
    return {
        ...functionDef,
        nodeInstances: functionDef.nodeInstances.map(updateNodePortValues),
    };
};

export const updatePortValues = (graph: DataGlueGraph): DataGlueGraph => {
    return {
        ...graph,
        nodeInstances: graph.nodeInstances.map(updateNodePortValues),
        functions: graph.functions.map(updateFunctionPortValues),
    };
};
